import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import Router from "next/router";

export const SignOutButton = () => {
  const onClick = () => {
    Router.push("/sign-out");
  };

  return (
    <div css={buttonWrapper}>
      <Button type="button" onClick={onClick}>
        ログアウト
      </Button>
    </div>
  );
};

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "30px",
  marginTop: "32px",
});
